import "./App.css";
import { useEffect } from "react";
import { useNavigate, useLocation  } from "react-router-dom";
import AuthenticatedApp from "./app/AuthenticatedApp";
// import UnAuthenticatedApp from "./app/UnAuthenticatedApp";
import { useAuth } from "./context/authContext";
import { baseURL } from "./services/api";
import { urlBase64ToUint8Array } from "./send-sw-details";

const WEB_PUSH_PUBLIC_KEY = "BL_9glFng3bdStxfOmhe7M3jT06FzBTUZsjbF8dFvBEhBslgVxay_mYJtmp8t3GevVCBzXyz-RxbkaYLSa3ZYOk";

function App() {
  const navigate = useNavigate();
  const { setIsLoggedin, userInfo } = useAuth();
  const { userId } = userInfo;
  const location = useLocation();

  useEffect(() => {
    // Only navigate to "/my-estate" if the user is not already on another route
    if (location.pathname === "/") {
      navigate("/my-estate");
    }
  }, [navigate, location.pathname]);

  useEffect(() => {
    if (!userId) return;

    async function subscribe() {
      const sw = await navigator.serviceWorker.ready;
      const push = await sw.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(WEB_PUSH_PUBLIC_KEY),
      });

      const payload = { subscription: push, userId };

      await fetch(`${baseURL}/push-notification/notifications/subscription`, {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
          "content-type": "application/json",
        },
      });
    }

    if ("serviceWorker" in navigator) {
      window.addEventListener("load", async () => {
        try {
          const sw = await navigator.serviceWorker.register("./sw.js");
          console.log("YES SW REGISTERED", sw);
        } catch (e) {
          console.log(e, "NO SW REGISTERED");
        }
      });
    }

    subscribe();
  }, [userId]);

  return <AuthenticatedApp />;
}

export default App;
